import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    apiURL: 'https://cms.museum-pankow.de/json/',
    pagesData: [],
    videosData: [],
    roomsData: [],
    markedVideo: null,
    selectedVideo: null,
    selectedRoom: null,
    playerStatus: false,
    modalState: false,
    homepageData: {},
    detailVideo: {},
    detailMode: false
  },
  getters: {
    getSelectedVideo( state ) {
      return  state.selectedVideo
    },
    getSelectedRoom( state ) {
      return  state.selectedRoom
    },
    getPlayerStatus( state ) {
      return state.playerStatus
    },
    getPagesData( state ) {
      return state.pagesData
    },
    getVideosData( state ) {
      return state.videosData.sort((a, b) => {
        if (a.orderNumber < b.orderNumber) {
          return -1
        }
        else if (a.orderNumber > b.orderNumber) {
          return 1
        }
        else {
          return 0
        }
      })
    },
    getRoomsData( state ) {
      return state.roomsData.sort((a, b) => {
        if (a.orderNumber < b.orderNumber) {
          return -1
        }
        else if (a.orderNumber > b.orderNumber) {
          return 1
        }
        else {
          return 0
        }
      })
    },
    getModalState( state ) {
      return state.modalState
    },
    getMarkedVideo( state ) {
      return state.markedVideo
    },
    getHomepageData( state ) {
      return state.homepageData
    },
    getDetailVideo( state ) {
      return state.detailVideo
    },
    getDetailMode( state ) {
      return state.detailMode
    }
  },
  mutations: {
    setSelectedVideo(state, payload) {
      state.selectedVideo = payload
    },
    setSelectedRoom(state, payload) {
      state.selectedRoom = payload
    },
    togglePlayerStatus(state) {
      state.playerStatus = !state.playerStatus
    },
    playerStatusPlay(state) {
      if (state.playerStatus === true) {
        state.playerStatus = false
      }
      state.playerStatus = true
    },
    setPagesData(state, payload) {
      state.pagesData = payload
    },
    setVideosData(state, payload) {
      const videos = payload.data.map(v => {
      const attrs = v.attributes
        return {
          titel: attrs.title,
          description: attrs.description,
          url: attrs.file.url,
          thumb: attrs.thumbnail ? attrs.thumbnail.url : undefined,
          previewTitle: attrs.previewtitle,
          orderNumber: attrs.order_number,
          icon: attrs.icon.url
        }
      })
      state.videosData = videos
    },
    setRoomsData(state, payload) {
      const rooms = payload.data.map(r => {
        const attrs = r.attributes
        return {
          titel: attrs.title,
          description: attrs.description,
          thumb: attrs.thumbnail ? attrs.thumbnail.url : undefined,
          orderNumber: attrs.order_number,
          icon: attrs.icon.url,
          details: attrs.details,
          audio: attrs.audio ? attrs.audio.url : undefined,
          video: attrs.video ? attrs.video.url : undefined
        }
      })
      state.roomsData = rooms
      const preSelected = rooms.find(r => r.orderNumber === '3')
      this.dispatch('selectRoom', preSelected)
    },
    setHomepageData(state, payload) {
      const attrs = payload.data.attributes
      state.homepageData.content = attrs.content

    },
    toggleModal(state) {
      state.modalState = !state.modalState
    },
    setMarkedVideo(state, payload) {
      state.markedVideo = payload
    },
    setDetailVideo(state, payload) {
      state.detailVideo = payload
      state.detailMode = true
    },
    resetDetailVideo(state) {
      state.detailVideo = {}
      state.detailMode = false
    }
  },
  actions: {
    fetchAPIData({ commit }) {
      Axios.get(this.state.apiURL + 'pages', {
        params: {

        }
      })
      .then(response => {
        commit('setPagesData', response.data)
      })
      Axios.get(this.state.apiURL + 'videos', {
        params: {

        }
      })
      .then(response => {
        commit('setVideosData', response.data)
      })
      Axios.get(this.state.apiURL + 'raeume', {
        params: {

        }
      })
      .then(response => {
        commit('setRoomsData', response.data)
      })
      Axios.get(this.state.apiURL + 'homepage/1', {
        params: {

        }
      })
      .then(response => {
        commit('setHomepageData', response.data)
      })
    },
    togglePlayerStatus({ commit }) {
      commit('togglePlayerStatus')
    },
    playerStatusPlay({ commit }) {
      commit('playerStatusPlay')
    },
    selectVideo({ commit }, payload) {
      commit('setSelectedVideo', payload)
    },
    selectRoom({ commit }, payload) {
      commit('setSelectedRoom', payload)
    },
    selectDetailVideo({ commit }, payload) {
      commit('setDetailVideo', payload)
    },
    resetDetailVideo({ commit }) {
      commit('resetDetailVideo')
    },
    toggleModal({ commit }) {
      commit('toggleModal')
    },
    setMarkedVideo({ commit }, payload) {
      commit('setMarkedVideo', payload)
    }
  },
  modules: {
  }
})
